export default __webpack_public_path__ + "static/media/login-background.038c5aa8.jpg";